import throttle from "./throttle";

export default function showHideMenuOnScroll() {

    let disableShowMenu = false;
    let scrolling = false;

    const bodyHeader = document.querySelector(".body-header");
    let lastDown = 0;
    window.onscroll = throttle(function (e) {
        scrolling = true;
        // print "false" if direction is down and "true" if up
        if (this.scrollY >= 6) {
            !disableShowMenu ? bodyHeader.classList.add("sticked") : null;
        }
        if (this.scrollY < 5) {
            bodyHeader.classList.remove("sticked");
        }
    }, 300);
    // window.onscroll = throttle(function (e) {
    //     scrolling = true;
    //     // print "false" if direction is down and "true" if up
    //     if (this.oldScroll > this.scrollY) {
    //         if (lastDown - this.scrollY > 300) {
    //             !disableShowMenu ? bodyHeader.classList.add("sticked") : null;
    //             lastDown = 0;
    //         }
    //         lastDown = this.scrollY;
    //         if (this.scrollY < window.innerHeight) {
    //             bodyHeader.classList.remove("sticked");
    //         }
    //     } else {
    //         bodyHeader.classList.remove("sticked");
    //         lastDown = this.scrollY;
    //     }
    //     this.oldScroll = this.scrollY;
    // }, 300);
    if (window.scrollY >= 6) {
        !disableShowMenu ? bodyHeader.classList.add("sticked") : null;
    }
    if (window.scrollY < 5) {
        bodyHeader.classList.remove("sticked");
    }
}